module.exports = __webpack_public_path__ + "static/media/293883.8dc4a8a7.png";